export default "__VITE_ASSET__CtpZUWpA__"